import NetxQueryClient, {
	SuccessResponse,
} from '@netx/core-next/lib/queryClient';
export type {QueryError} from '@netx/core-next/lib/queryClient';
import {type IAsset} from '@netx/core-asset-next/schema';

export const SET_ASSET_DATA_CLIENT_ATTRS = [
	'attributeIds',
	'attributeNames',
	'attributeValues',
	'activatingTemplate',
	'audioUrl',
	'customThumbnailFile',
	'progress',
	'thumbnailUpdating',
	'videoUrl',
	'zoomUrl',
];

export const getAssetDataWithoutClientAtts = (assetData: IAsset) =>
	Object.keys(assetData)
		.filter((key) => !SET_ASSET_DATA_CLIENT_ATTRS.includes(key))
		.reduce<IAsset>((data, key) => {
			return Object.assign(data, {
				[key]: assetData[key as keyof IAsset],
			});
		}, {} as IAsset);

/**
 * `setAssetData` request params
 * (what is used to send to server)
 */
export interface SetAssetDataRequestOptions extends IAsset {}

/**
 * `setAssetData` request
 * (what gets sent to the server)
 */
export type SetAssetDataRequest = [SetAssetDataRequestOptions];

/**
 * `setAssetData` response
 * (what comes back from the server)
 */
export type SetAssetDataResponse = SuccessResponse<SetAssetDataResult>;

/**
 * `setAssetData` result
 * (what is utilized from the server response)
 */
export interface SetAssetDataResult extends IAsset {}

export const setAssetDataEndpoint = 'setAsset';

/**
 * Set asset expiration
 * @param fetchParams Fetch params
 */
export const setAssetData = async (assetData: SetAssetDataRequestOptions) => {
	const client = NetxQueryClient();

	const requestParams: SetAssetDataRequest = [
		getAssetDataWithoutClientAtts(assetData),
	];

	return client
		.post<SetAssetDataResponse>(setAssetDataEndpoint, requestParams)
		.then((response) => response.data.result);
};

export default setAssetData;
